// Header row 1 user dropdown. Sign out + user settings link.

import { signOut } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../lib/firebase.js'
import { useDropdown } from './useDropdown.js'

export function UserMenu() {
  const [user] = useAuthState(auth)
  const navigate = useNavigate()
  const { open, setOpen, ref } = useDropdown()

  async function handleSignOut() {
    setOpen(false)
    await signOut(auth)
    navigate('/', { replace: true })
  }

  const initial = user?.email?.[0]?.toUpperCase() ?? user?.displayName?.[0]?.toUpperCase() ?? '·'

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="User menu"
        onClick={() => setOpen((o) => !o)}
        className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--color-sandstone)] text-sm font-medium text-[var(--color-basalt)] hover:bg-[var(--color-schist)]/30"
      >
        {initial}
      </button>

      {open && (
        <div
          role="menu"
          className="absolute right-0 top-9 z-40 min-w-[200px] rounded-md border border-[var(--color-sandstone)] bg-[var(--color-limestone)] py-1 shadow-lg"
        >
          <div className="px-3 py-2 text-xs text-[var(--color-schist)]">
            {user?.email ?? 'signed in'}
          </div>
          <div className="my-1 border-t border-[var(--color-sandstone)]" />
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false)
              navigate('/user/settings')
            }}
            className="block w-full px-3 py-2 text-left text-sm text-[var(--color-slate)] hover:bg-[var(--color-sandstone)]"
          >
            User settings
          </button>
          <button
            type="button"
            role="menuitem"
            onClick={handleSignOut}
            className="block w-full px-3 py-2 text-left text-sm text-[var(--color-slate)] hover:bg-[var(--color-sandstone)]"
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}
